// component
import SvgColor from '../../../components/svg-color';

import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import GroupIcon from '@mui/icons-material/Group';
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { useTranslation } from "react-i18next";
// ----------------------------------------------------------------------

const icon = (name) => 

<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const navConfig = [
  {
    title: 'Create Trip',
    path: '/dashboard/app',
    icon: <DashboardCustomizeIcon />,
  },
  {
    title: 'users',
    path: '/dashboard/user',
    icon: <GroupIcon />,
  },
  {
    title: 'trips',
    path: '/dashboard/trip',
    icon: <TimeToLeaveIcon />,
  },
  {
    title: 'schedule trips',
    path: '/dashboard/schedule',
    icon: <DepartureBoardIcon />,
  },
  {
    title: 'payment trips',
    path: '/dashboard/payment',
    icon: <CreditScoreIcon />,
  },
];

export default navConfig;

